import ApiService from "@/core/services/ApiService";
import { Actions } from "@/store/enums/StoreEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";

export interface Subscription {
  subscription: unknown;
}

export interface Subscriptions {
  subscription: Subscription;
}

@Module
export default class SubscriptionModule
  extends VuexModule
  implements Subscriptions
{
  subscription = {} as Subscription;

  @Action
  async [Actions.GET_USER_AVAILABLE_PLANS]() {
    try {
      const response = await ApiService.get("user/plans");
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.GET_SUBSCRIPTIONS_OF_PROJECT](projectId) {
    try {
      const response = await ApiService.get(`subscription/${projectId}`);
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.GET_SUBSCRIPTION_CHECKOUT_FORM]({ projectId, planId }) {
    try {
      const response = await ApiService.get(
        `subscription/${projectId}/${planId}`
      );
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.GET_UPGRADE_CHECKOUT_FORM]({ subscriptionId, planId }) {
    try {
      const response = await ApiService.post(
        `subscription/${subscriptionId}/upgrade/${planId}`,
        {}
      );
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.GET_CHANGE_PAYMENT_CHECKOUT_FORM]({ subscriptionId }) {
    try {
      const response = await ApiService.post(
        `subscription/${subscriptionId}/change/payment-method`,
        {}
      );
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.CANCEL_PROJECT_SUBSCRIPTION]({ subscriptionId }) {
    try {
      const response = await ApiService.post(
        `subscription/${subscriptionId}/cancel`,
        {}
      );
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }
}
